export enum EchelleNotation {
  LETTRE = 'LETTREE',
  REUSSITE_ECHEC = 'REUSSITE_ECHEC',
}
